export default __webpack_public_path__ + "static/logo-36823062df94ce55007da83605b5ced1.png";